import { color } from '@veneer/tokens/dist/tokens'
import { styled, css } from 'styled-components'

import { applyStylesWhen } from '@/utils/apply-styles-when'

export const Container = styled.div`
  && a,
  && a:visited,
  && a:hover,
  && a:active,
  && a:focus {
    text-decoration: none;
  }

  ${applyStylesWhen(
    { isHpx: true },
    css`
      && a,
      && a:visited,
      && a:hover,
      && a:active,
      && a:focus {
        color: ${color.royalBlue7};
      }
    `,
  )}
`
